import mark from "../../assets/imgs/videobrief-mark.png";

export default function VideoBriefLogo({
  variant = "light",
  iconOnly = false,
  size = "md",
  className = "",
}) {
  const monochrome = variant === "monochrome";
  const toneClass = variant === "dark"
    ? "vb-brand-logo--on-dark"
    : variant === "auto"
      ? "vb-brand-logo--auto"
      : "";

  return (
    <span
      className={`vb-brand-logo vb-brand-logo--${size} ${toneClass} ${monochrome ? "vb-brand-logo--mono" : ""} ${iconOnly ? "vb-brand-logo--icon" : ""} ${className}`}
    >
      <img
        className="vb-brand-logo__mark"
        src={mark}
        alt={iconOnly ? "VideoBrief.ai" : ""}
        aria-hidden={iconOnly ? undefined : "true"}
      />
      {!iconOnly && (
        <span className="vb-brand-logo__type">
          VideoBrief<span>.ai</span>
        </span>
      )}
    </span>
  );
}
